import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { appInsights } from '../../AppInsights';
import { ISearchHistory } from '../../intefaces';
import { DataService, IDataService } from '../../services';
import styles from  './SearchBar.module.scss';

interface ISearchProps {
    searchTextProp: any;
    searchText: string;
    cleared: boolean;
}

interface ISearchState {
    searchText: string;
    redirect: boolean;
}

export class SearchBar extends React.Component<ISearchProps, ISearchState> {
    private _dataService: IDataService = new DataService();

    constructor(props: ISearchProps) {
        super(props);

        this.state = {
            searchText: this.props.searchText,
            redirect: false
        }
    }

    componentDidUpdate(prevProps: ISearchProps, prevState: ISearchState) {
        if (prevProps.searchText !== this.props.searchText) {
            this.setState({
                searchText: this.props.searchText
            })
        }
        
        if (this.props.cleared !== prevProps.cleared) {
            this.onSearchHandler();
        }
    }

    public render() {
        const fuzzy = localStorage.getItem('fuzzySearch') || 'true';
        const searchQuery = `/search?q=${this.state.searchText}&fuzzy=${fuzzy}`;
        return (
            <div>
                {this.state.redirect ? <Redirect to={searchQuery} /> : <div />}
                <div onKeyDown={e => this.onEnterButton(e)} className={styles.searchBar}>
                    <div className={styles.search}>
                        <input
                            placeholder='Search...'
                            onChange={e => this.onTextChange(e)} value={this.state.searchText}
                        />
                        <button type="submit" onClick={this.onSearchHandler.bind(this)} aria-label='search'>
                            <FontAwesomeIcon icon={faSearch} />
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    private onTextChange(e: any) {
        this.setState({
            searchText: e.target.value
        });
    }

    private async onSearchHandler() {
        appInsights.trackEvent({name: 'search text', properties: {"text": this.state.searchText}}, {key: this.state.searchText});
        this.props.searchTextProp(this.state.searchText);
        const fuzzy = localStorage.getItem('fuzzySearch') || 'true';
        let _seerchHistory: ISearchHistory = { searchTerm: this.state.searchText, searchUrl: `${window.location.origin}/search?q=${this.state.searchText}&fuzzy=${fuzzy}`};
        await this._dataService.CallUpdateSearchHistory(_seerchHistory);
        this.setState({ redirect: true });
    }

    private onEnterButton = (event: any) => {
        if (event.keyCode === 13) {
            this.onSearchHandler();
        }
    }
}